import styled, { css } from 'styled-components';

const appliedFilterStyles = css`
  ${({ theme }) => css`
    height: 26px;
    padding: ${theme.padding['3xs']} ${theme.padding['2xs']};
    background-color: ${theme.colors.background.component['active-filter'].rest};

    &:hover,
    &:focus {
      background-color: ${theme.colors.background.component['active-filter'].hover};
    }
  `}
`;

const colorFacetStyles = css<{ $bgColor?: string }>`
  ${({ theme }) => css`
    font-size: ${theme.font.size[2]};
    font-weight: ${theme.variables.font.weight.regular};
  `}
  ${({ $bgColor }) =>
    $bgColor &&
    css`
      display: inline-block;
      width: 16px;
      height: 16px;
      overflow: hidden;
      background: ${$bgColor === '#666666'
        ? 'linear-gradient(221deg, #5098C7 17.31%, #89B750 34.33%, #F8D557 51.36%, #F57130 68.39%, #EB483F 85.42%)'
        : $bgColor};
      border-radius: 50%;
    `};
`;

export const AF = {
  AppliedFilterWrapper: styled.li`
    list-style: none;
  `,

  AppliedFilter: styled.button`
    ${({ theme }) => css`
      display: flex;
      box-sizing: border-box;
      list-style: none;
      white-space: nowrap;
      min-width: max-content;
      align-items: center;
      cursor: pointer;
      font-weight: ${theme.variables.font.weight.regular};
      border-radius: 1px;
      ${appliedFilterStyles};
    `}
  `,

  AppliedFilterLabel: styled.span<{
    $bgColor?: string;
    $height?: string;
    $hasBorder?: boolean;
  }>`
    box-sizing: border-box;
    margin-right: ${({ $bgColor }) => ($bgColor ? '4px' : '6px')};
    color: ${({ $bgColor, theme }) => ($bgColor ? 'transparent' : theme.colors.content.primary)};
    line-height: ${({ $height }) => $height || '16px'};

    ${colorFacetStyles}

    ${({ $hasBorder }) =>
      $hasBorder &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.content.primary};
      `}
  `,

  RemoveAppliedIconWrapper: styled.div`
    ${({ theme }) => css`
      align-self: center;
      display: flex;
      align-items: center;
      color: ${theme.colors.content.primary};

      svg {
        width: ${theme.size[3]};
        height: ${theme.size[3]};
      }
    `}
  `,

  ClearAll: styled.button`
    display: flex;
    box-sizing: border-box;
    list-style: none;
    white-space: nowrap;
    min-width: max-content;
    align-items: center;
    cursor: pointer;

    ${appliedFilterStyles}
  `,

  Label: styled.span`
    ${({ theme }) => css`
      font-size: ${theme.font.size[2]};
      color: ${theme.colors.content.secondary};
      margin-right: ${theme.padding['4xs']};
      line-height: 1.4;
    `}
  `,
};
